import { render, staticRenderFns } from "./real-amount.vue?vue&type=template&id=09bfaca9"
import script from "./real-amount.vue?vue&type=script&lang=js"
export * from "./real-amount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports